module.exports = __webpack_public_path__ + "img/Self-Serve.90075a65.svg";